import { ViewModel, View, ObservableArray } from "binder"
import { MachineManipulationView } from "./machineManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { MachineEditorViewModel, MachineInserter, MachineUpdater } from "./machineEditor/machineEditor-viewModel";
import { IMachine } from "./IMachine";

export class MachineManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف ماشین';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.machines = ObservableArray.create<Machine>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new MachineManipulationView();
    }
    public getTypeId(): string {
        return "VM-04FDF43E-6644-4145-93AB-4F44664C50E4"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set machines(v: ObservableArray<Machine>) { this._machines = v; } public get machines(): ObservableArray<Machine> { return this._machines; } private _machines: ObservableArray<Machine>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/ListAllMachines', {
                FilteringInformation: filteringInformation
            });
            this.machines.update(...result.Machines.map((x, i) => {
                let m = new Machine(this);
                m.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                m.id = x.Id;
                m.serialId = x.SerialNumber;
                m.machineModelId = x.MachineModelId;
                m.machineModelName = x.MachineModelName;
                m.machineModelCode = x.MachineModelCode;
                return m;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new MachineEditorViewModel(this, new MachineInserter());
        popup.isCreate = true;
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(machineModel: IMachine) {
        let popup = new MachineEditorViewModel(this, new MachineUpdater());
        popup.isCreate = false;
        await machineModel.cloneTo(popup);
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(machine: Machine): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer("/Complex/ToolPlaceHolderServices/DeleteMachine", {
                    MachineId: machine.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class Machine extends ViewModel implements IMachine {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MachineManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.isCreate = true;
    }

    private _typedParent: MachineManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set serialId(v: string) { this._serialId = v; } public get serialId(): string { return this._serialId; } private _serialId: string;
    public set machineModelId(v: string) { this._machineModelId = v; } public get machineModelId(): string { return this._machineModelId; } private _machineModelId: string;
    public set machineModelName(v: string) { this._machineModelName = v; } public get machineModelName(): string { return this._machineModelName; } private _machineModelName: string;
    public set machineModelCode(v: string) { this._machineModelCode = v; } public get machineModelCode(): string { return this._machineModelCode; } private _machineModelCode: string;
    public set serials(v: string[]) { this._serials = v; } public get serials(): string[] { return this._serials; } private _serials: string[];
    public set isCreate(v: boolean) { this._isCreate = v; } public get isCreate(): boolean { return this._isCreate; } private _isCreate: boolean;

    setMachineModelId(id: string) {
        this.machineModelId = id;
    }
    getMachineModelId(): string {
        return this.machineModelId;
    }

    setSerials(serials: string[]) {
        this.serials = serials;
    }
    getSerials(): string[] {
        return this.serials;
    }

    async cloneTo(machine: IMachine) {
        machine.id = this.id;
        machine.serialId = this.serialId;
        machine.setMachineModelId(this.machineModelId);
        machine.setSerials(machine.getSerials());
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
